import React, { useEffect } from 'react';

const ThemeSwitcher = () => {
  const switchTheme = (theme) => {
    const themeLink = document.getElementById('theme-stylesheet');
    if (themeLink) {
      themeLink.setAttribute('href', `/themes/${theme}.css`);
      localStorage.setItem('selectedTheme', `/themes/${theme}.css`);
    } else {
      console.error('Theme link element not found');
    }
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('selectedTheme') || 'default';
    const themeLink = document.getElementById('theme-stylesheet');
    if (themeLink) {
      themeLink.setAttribute('href', `/themes/${savedTheme}.css`);
    }
  }, []);

  return (
    <div className="theme-switcher text-center my-4 d-flex justify-content-center align-items-center">
      <div
        className="theme-icon default mx-2"
        onClick={() => switchTheme('default')}
        title="Default Theme"
      ></div>
      <div
        className="theme-icon dark mx-2"
        onClick={() => switchTheme('dark')}
        title="Dark Theme"
      ></div>
    </div>
  );
};

export default ThemeSwitcher;
